exports = module.exports = require("../../../../../web-hosted/node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".Logo__Logo__3e6ty {\n  -webkit-transition: all 0.1s ease-out;\n  -o-transition: all 0.1s ease-out;\n  transition: all 0.1s ease-out;\n}\n\n.Logo__Img__1pzi4 {\n  width: 100%;\n  height: 100%;\n  border-radius: 5px;\n  position: absolute;\n  top: 0px;\n  left: 0px;\n}\n\n/* .Logo:hover {\n  opacity: 0.7;\n  cursor: pointer;\n} */\n", ""]);

// exports
exports.locals = {
	"Logo": "Logo__Logo__3e6ty",
	"Img": "Logo__Img__1pzi4"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!../shared-components/src/components/UI/Logo/Logo.css
// module id = 376
// module chunks = 0